// src/dokumentklassen/rechnung/PositionenView.jsx
// Zeigt die Rechnungspositionen in kleiner Schrift unterhalb der Haupttabelle an.
// Standardmäßig ausgeblendet, über eine Checkbox einblendbar.
//
// Der aktuelle Standard-Prompt (Eingangsrechnung_Optimiert) liefert "positionen" als
// Array von Objekten mit ausschließlich "GesamtpreisEur" (keine Beschreibung) - passend
// zum Rechnungsposition-Modell in RechnungCustom. normalizePosition() ist trotzdem
// tolerant gegenüber einem Beschreibungsfeld bzw. dem älteren Tupel-Format
// [beschreibung, betrag], falls sich der Prompt später nochmal ändert.
import React, { useState } from 'react'
import { formatCurrency } from '../../components/shared/formatters'

function normalizePosition (item, index) {
  if (Array.isArray(item)) {
    const [beschreibung, betrag] = item
    return {
      label: beschreibung || `Position ${index + 1}`,
      betrag: betrag ?? null
    }
  }
  if (item && typeof item === 'object') {
    const beschreibung = item.beschreibung ?? item.Beschreibung ?? null
    const betrag =
      item.GesamtpreisEur ??
      item.gesamtpreis_eur ??
      item.einzelpreis_eur ??
      null
    return { label: beschreibung || `Position ${index + 1}`, betrag }
  }
  return { label: `Position ${index + 1}`, betrag: null }
}

function PositionenView ({ positionen }) {
  const [sichtbar, setSichtbar] = useState(false)

  if (!Array.isArray(positionen) || positionen.length === 0) return null

  return (
    <div className='positionen-view'>
      <label className='positionen-toggle'>
        <input
          type='checkbox'
          checked={sichtbar}
          onChange={e => setSichtbar(e.target.checked)}
        />
        Positionen anzeigen ({positionen.length})
      </label>

      {sichtbar && (
        <table className='positionen-table'>
          <thead>
            <tr>
              <th>Position</th>
              <th>Betrag (EUR)</th>
            </tr>
          </thead>
          <tbody>
            {positionen.map((item, index) => {
              const { label, betrag } = normalizePosition(item, index)
              return (
                <tr key={index}>
                  <td>{label}</td>
                  <td>{formatCurrency(betrag)}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      )}
    </div>
  )
}

export default PositionenView
